import React from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Paper,
  Stack,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

export default function TerritoryDetailPage() {
  const navigate = useNavigate();

  // Mock leads data for now
  const leads = [
    {
      id: 1,
      first_name: "John",
      last_name: "Doe",
      address: "123 Main St, Springfield",
      status: "Active",
      rep: "Alex Johnson",
    },
    {
      id: 2,
      first_name: "Sarah",
      last_name: "Connor",
      address: "45 Oak Ave, Centerville",
      status: "Pending",
      rep: "Michael Smith",
    },
    {
      id: 3,
      first_name: "David",
      last_name: "Lee",
      address: "99 Pine Rd, Rivertown",
      status: "Closed",
      rep: "Jessica Adams",
    },
  ];

  const columns = [
    { field: "first_name", headerName: "First Name", flex: 1 },
    { field: "last_name", headerName: "Last Name", flex: 1 },
    { field: "address", headerName: "Address", flex: 2 },
    { field: "status", headerName: "Status", flex: 1 },
    { field: "rep", headerName: "Assigned Rep", flex: 1 },
  ];

  return (
    <Box
      p={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
        backgroundColor: "background.default",
      }}
    >
      {/* Page Header */}
      <Typography
        variant="h5"
        fontWeight="600"
        gutterBottom
        sx={{ alignSelf: "flex-start" }}
      >
        Territory Details
      </Typography>

      <Button
        variant="outlined"
        sx={{ mb: 3, alignSelf: "flex-start" }}
        onClick={() => navigate("/territories")}
      >
        ← Back to Territories
      </Button>

      {/* Main Form Container */}
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 3,
          width: "120%", // ⬅️ Increased width by 20%
          maxWidth: 1000,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mb: 5,
        }}
      >
        <Stack spacing={3} sx={{ width: "100%" }}>
          <TextField
            fullWidth
            label="Territory Name"
            placeholder="Example: North Region"
            variant="outlined"
          />

          <TextField
            fullWidth
            label="Description"
            placeholder="Short description about this territory..."
            multiline
            minRows={3}
            variant="outlined"
          />

          <TextField
            fullWidth
            label="Manager"
            select
            defaultValue=""
            variant="outlined"
          >
            <MenuItem value="">Select Manager</MenuItem>
            <MenuItem value="1">John Doe</MenuItem>
            <MenuItem value="2">Jane Smith</MenuItem>
          </TextField>

          <TextField
            fullWidth
            label="Assigned Rep"
            select
            defaultValue=""
            variant="outlined"
          >
            <MenuItem value="">Select Rep</MenuItem>
            <MenuItem value="1">Mark Johnson</MenuItem>
            <MenuItem value="2">Emily Davis</MenuItem>
          </TextField>

          <TextField
            fullWidth
            label="Lead Count"
            value="3"
            InputProps={{ readOnly: true }}
            variant="outlined"
          />

          {/* Action Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 2,
              gap: 2,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{ flex: 1 }}
              onClick={() => alert("Changes saved (mock)")}
            >
              Save Changes
            </Button>

            <Button
              variant="contained"
              color="error"
              sx={{ flex: 1 }}
              onClick={() => alert("Territory deleted (mock)")}
            >
              Delete Territory
            </Button>
          </Box>
        </Stack>
      </Paper>

      {/* Leads Table Section */}
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 3,
          width: "120%",
          maxWidth: 1000,
          backgroundColor: "background.paper",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" fontWeight="600">
            Leads
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => alert("Add Lead clicked (mock)")}
          >
            + Add Lead
          </Button>
        </Box>

        <Box sx={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={leads}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            disableSelectionOnClick
          />
        </Box>
      </Paper>
    </Box>
  );
}
